import { api } from './api'

export const fetchCurrentSync = (table) => api.get(`/sync-table/${table}`)
